<template>
  <div>
    <common-dialog ref="dialog" width="1200px" title="选择待结算加工信息" in-dialog @create-opened="onCreateOpened" @closed="onClosed">
      <template slot="form">
        <el-row class="border" style="margin-bottom: 5px;">
          <el-row :gutter="15">
            <el-col :span="24">
              <div class="flex">
                <el-button type="primary" @click="query">查询</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="单据日期">
                <range-picker :date="[queryData.DocDateStart, queryData.DocDateEnd]" @change="x=>{queryData.DocDateStart=x.Start;queryData.DocDateEnd=x.End;}"></range-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="模具名称">
                <el-input v-model="queryData.MouldName" placeholder="请输入模具名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="加工商">
                {{TradeUnitName}}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="queryData.WorkDocNo" type="text" placeholder="请输入工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="胶件名称">
                <el-input v-model="queryData.ProductName" placeholder="请输入胶件名称" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-table ref="table" @selection-change="x=>data.Rows1=x" :data="data.Details1" border>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据日前" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="工单号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.WorkDocNo}}</template>
          </el-table-column>
          <el-table-column label="模号" min-width="150">
            <template slot-scope="{row}">{{row.MouldNo}}</template>
          </el-table-column>
          <el-table-column label="模具名称" min-width="150">
            <template slot-scope="{row}">{{row.MouldName}}</template>
          </el-table-column>
          <el-table-column label="未结算模数" prop="ProductSpec" min-width="100">
            <template slot-scope="{row}">
              <span>{{toNumber(row.StockInQuantity - row.OutPocCostQuantity)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计入库模数" prop="StockInQuantity" width="100">
            <template slot-scope="{row}">{{toNumber(row.StockInQuantity)}}</template>
          </el-table-column>
          <el-table-column label="工单模数" width="100">
            <template slot-scope="{row}">{{toNumber(row.Quantity)}}</template>
          </el-table-column>
          <el-table-column label="加工阶段" width="80">
            <span>注塑</span>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">确 认</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/production/workDoc").default,
      queryData: {
        DocDateStart: "",
        DocDateEnd: "",
        MouldName: "",
        ProductionDpId: 0,
        WorkDocNo: "",
        ProductName: "",
        ToOutPocCost: true,
      },
      TradeUnitName: "",
      data: {
        Details1: [],
        Rows1: [],
      },
    };
  },
  computed: {},
  methods: {
    toNumber(num) {
      return num > 0 ? num : 0;
    },
    query() {
      var params = this.$commonJs.obj.removeNullKey(this.queryData);
      this.api.getWdgDetail(params).then((res) => {
        console.log("res", res);
        this.data.Details1 = res.Data;
      });
    },
    onCreateOpened(data) {
      console.log("添加", this.$commonJs.toJson(data));
      this.queryData.ProductionDpId = data.TradeUnitId;
      this.TradeUnitName = data.TradeUnitName;
      var params = this.$commonJs.obj.removeNullKey(this.queryData);
      this.api.getWdgDetail(params).then((res) => {
        console.log("res", res);
        this.data.Details1 = res.Data;
      });
    },
    save() {
      console.log("保存", this.data);
      var rows = this.data.Rows1;
      if (rows.length != 0) {
        this.$emit("select", rows);
        this.close(true);
      } else {
        this.$message.warning("请选择数据");
      }
    },
    onClosed() {
      this.data.Details1 = [];
      this.data.Rows1 = [];
      this.TradeUnitName = "";
    },
  },
};
</script> 

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
}
</style>